import { ReactFlowInstance } from '@xyflow/react';
import { useEffect, useState } from 'react';

export const useRfInstance = () => {
    const [rfInstance, setRfInstance] = useState<ReactFlowInstance | null>(null);

    useEffect(() => {
        if (rfInstance) {
            rfInstance.fitView({ padding: 2, minZoom: 1 });
        }
    }, [rfInstance]);

    return { rfInstance, setRfInstance };
};
